import { render, staticRenderFns } from "./ProductAnotherColors.vue?vue&type=template&id=588167de&"
import script from "./ProductAnotherColors.vue?vue&type=script&lang=js&"
export * from "./ProductAnotherColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports